<template>
  <v-dialog
    v-model="showModal"
    max-width="700"
    persistent
    :retain-focus="false"
  >
    <v-card class="text-center">
      <template v-if="errorMessage">
        <v-alert
          type="error"
        >
          {{ errorMessage }}
        </v-alert>
      </template>
      <validation-observer
        ref="validator"
        v-slot="{ handleSubmit }"
      >
        <v-card-title class="text-sm-left font-weight-bold">
          <template v-if="isCreate">
            Thêm mới
          </template>
          <template v-else>
            Cập nhật
          </template>

          <v-spacer />

          <v-icon
            aria-label="Close"
            @click="hideModal"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text class="px-6">
          <v-col cols="12" class="py-0">
            <validation-provider
                :rules="{ required: true }"
                v-slot="{ errors }"
                name="Call center">
              <v-autocomplete
                  v-model="prioritySetting.contactSourceId"
                  :items="contactSourceList"
                  :error-messages="errors"
                  item-text="name"
                  item-value="id"
                  label="Nguồn"
                  color="primary"
                  eager
              />
            </validation-provider>
          </v-col>
          <v-col cols="12" class="py-0">
            <validation-provider
                :rules="{ required: true }"
                v-slot="{ errors }"
                name="Nhóm sản phẩm">
              <v-autocomplete
                  v-model="prioritySetting.productGroupId"
                  :items="productGroupList"
                  :error-messages="errors"
                  item-text="name"
                  item-value="id"
                  label="Nhóm sản phẩm"
                  color="primary"
                  clearable
              />
            </validation-provider>
          </v-col>
          <v-col cols="12" class="py-0">
            <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                :rules="{regex: regex.isNumber}"
                name="Priority">
              <v-text-field
                  v-model.trim="prioritySetting.priority"
                  label="Priority"
                  :error-messages="errors"
                  color="primary"
              />
            </validation-provider>
          </v-col>
        </v-card-text>
        <v-card-actions class="px-0 group-btn--form">
          <v-btn
            color="success"
            @click.prevent="handleSubmit(save)"
          >
            Lưu lại
          </v-btn>
          <v-btn
            class="ml-0"
            color="primary"
            @click="hideModal"
          >
            Hủy bỏ
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>
  import { regex } from '../../../helpers/constants';
  import RepositoryFactory from '../../../repositories/RepositoryFactory'
  const PrioritySettingRepository = RepositoryFactory.get('priority_setting')
  export default {
    $_veeValidate: {
      validator: 'new',
    },
    props: {
      contactSourceList: {
        default: () => ([]),
      },
      productGroupList: {
        default: () => ([]),
      },
    },
    data () {
      return {
        showModal: false,
        prioritySetting: {},
        isCreate: true,
        dataPrioritySettings: [],
        errorMessage: '',
        regex
      }
    },
    created () {
      Bus.$on('priority-setting-show-form', (dataPrioritySetting) => {
        this.showModal = true
        this.prioritySetting = _.cloneDeep(dataPrioritySetting)
        if (dataPrioritySetting.id) this.isCreate = false
        else this.isCreate = true
      })
    },
    methods: {
      hideModal: function () {
        this.showModal = false
        this.isCreate = true
        this.errorMessage = ''
        this.$refs.validator.reset()
      },
      async save () {
        const dataPrioritySetting = {
          contactSourceId: _.trim(this.prioritySetting.contactSourceId),
          productGroupId: _.trim(this.prioritySetting.productGroupId),
          priority: _.trim(this.prioritySetting.priority) ? _.trim(this.prioritySetting.priority) : 0,
        }
        this.appLoadingData(true)
        let response = {}
        if (this.isCreate) {
          response = await PrioritySettingRepository.create(dataPrioritySetting)
          this.appLoadingData(false)
          if (!response.success) {
            this.errorMessage = _.get(response, 'message', '')
          } else {
            this.errorMessage = ''
            this.showModal = false
            this.$swal({
              title: 'Thêm cấu hình ưu tiên thành công',
              confirmButtonText: 'Đồng ý',
            }).then(() => {
              Bus.$emit('priority-setting-list-reload')
            })
          }
        } else {
          response = await PrioritySettingRepository.update(this.prioritySetting.id, dataPrioritySetting)
          this.appLoadingData(false)
          if (!response.success) {
            this.errorMessage = _.get(response, 'message', '')
          } else {
            this.errorMessage = ''
            this.showModal = false
            this.$swal({
              title: 'Cập nhật thành công',
              confirmButtonText: 'Đồng ý',
            }).then(() => {
              Bus.$emit('priority-setting-list-reload')
            })
          }
        }
      }
    },
  }
</script>
